import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { calcPitch, calcRise, concatClasses, toDegree, toRadian } from '../../utils/fns'
import { InputGroup } from './InputGroup'

import '../../globals/scss/components/ratioInput.scss'
import { useLazyEffect } from '../../utils/hooks'

const getClassName = (classes) => concatClasses('ratioInput', classes)

const RatioInput = React.forwardRef((props, ref) => {
  const { disabled, error, value, onChange, name } = props
  const [radian, setRadian] = useState(value)
  const [degree, setDegree] = useState(0)
  const [focused, setFocused] = useState(false)

  useEffect(() => {
    if (!focused) {
      setRadian(+value)
      setDegree(toDegree(calcPitch(+value)))
    }
  }, [value])

  useLazyEffect(() => {
    onChange(name, radian)
  }, [radian])

  const handleRadianChange = (e) => {
    const { value } = e.target
    setRadian(value)
    setDegree(value === '' || isNaN(value) ? value : toDegree(calcPitch(+value)))
  }

  const handleDegreeChange = (e) => {
    const { value } = e.target
    setDegree(e.target.value)
    setRadian(value === '' || isNaN(value) ? value : calcRise(toRadian(+value)))
  }

  const handleBlur = () => {
    setFocused(false)
  }

  const handleFocus = () => {
    setFocused(true)
  }

  return (
    <React.Fragment>
      <div ref={ref} className={getClassName(disabled ? 'ratioInput--disabled' : '')}>
        <InputGroup
          ref={ref}
          name="radian"
          value={radian}
          onChange={handleRadianChange}
          disabled={disabled}
          addonAfter="/12"
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        <span>=</span>
        <InputGroup
          value={degree}
          onChange={handleDegreeChange}
          disabled={disabled}
          name="degree"
          addonAfter="°"
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>
      {error && <span className="input-error is-visible">{error}</span>}
    </React.Fragment>
  )
})

RatioInput.displayName = 'RatioInput'

RatioInput.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
}

export default RatioInput
